import React from 'react';
import { useTranslation } from 'react-i18next';
import SuccessMessage from '../../SuccessMessage';

type SubmitResult = {
  success: boolean,
  message?: string,
};

type Step6ResultProps = {
  submitResult: SubmitResult,
  onClose: () => void,
  onRestart: () => void,
};

function Step6Result( { submitResult, onClose, onRestart }: Step6ResultProps ) {
  const { t } = useTranslation();
  const description = submitResult.success
    ? t( 'admin.processes.submitSuccess' )
    : ( submitResult.message ?? '' );

  return (
    <SuccessMessage
      success={submitResult.success}
      description={description}
      primaryButtonLabel={submitResult.success ? t( 'close' ) : undefined}
      onPrimaryClick={submitResult.success ? onClose : undefined}
      onRestart={submitResult.success ? undefined : onRestart}
    />
  );
}

export default Step6Result;
